import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0aa609be")

_pushScopeId("data-v-0aa609be")
const _hoisted_1 = { class: "subtitle" }
const _hoisted_2 = { class: "scoreboxbig" }
const _hoisted_3 = { class: "score" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "fen" }, "分", -1)
const _hoisted_5 = { class: "scorebigtip" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "chartname" }, "24小时脉搏波变化图", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "chartname" }, "24小时Poincare散点图", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "chartname" }, "24小时心率分布图", -1)
const _hoisted_9 = { class: "tb" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "itme" }, [
  /*#__PURE__*/_createVNode("div", null, "检测指标"),
  /*#__PURE__*/_createVNode("div", null, "检测结果"),
  /*#__PURE__*/_createVNode("div", null, "提示"),
  /*#__PURE__*/_createVNode("div", null, "参考范围")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "itme"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", null, "XAR", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_15 = /*#__PURE__*/_createVNode("div", null, "76.62~84.36", -1)
const _hoisted_16 = {
  key: 1,
  class: "itme"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", null, "XST", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_20 = /*#__PURE__*/_createVNode("div", null, "5.9~8.3", -1)
const _hoisted_21 = {
  key: 2,
  class: "itme"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", null, "XVLA", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_24 = /*#__PURE__*/_createVNode("div", null, ">23", -1)
const _hoisted_25 = {
  key: 3,
  class: "itme"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("div", null, "XASRD", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_28 = /*#__PURE__*/_createVNode("div", null, ">13.0", -1)
const _hoisted_29 = {
  key: 4,
  class: "itme"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("div", null, "XBAR", -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_33 = /*#__PURE__*/_createVNode("div", null, "130.0~270.0", -1)
const _hoisted_34 = {
  key: 5,
  class: "itme"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("div", null, "XAAR", -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_38 = /*#__PURE__*/_createVNode("div", null, "160.0~420.0", -1)
const _hoisted_39 = {
  key: 6,
  class: "itme"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("div", null, "GSA", -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_42 = /*#__PURE__*/_createVNode("div", null, "≥15.56", -1)
const _hoisted_43 = {
  key: 7,
  class: "itme"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("div", null, "GLA", -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_46 = /*#__PURE__*/_createVNode("div", null, ">80.61", -1)
const _hoisted_47 = {
  key: 8,
  class: "itme"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("div", null, "GSDA", -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_50 = /*#__PURE__*/_createVNode("div", null, ">870.0", -1)
const _hoisted_51 = {
  key: 9,
  class: "itme"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("div", null, "SVL", -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_54 = /*#__PURE__*/_createVNode("div", null, ">93.0", -1)
const _hoisted_55 = {
  key: 10,
  class: "itme"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("div", null, "SMR", -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_59 = /*#__PURE__*/_createVNode("div", null, "65.0~79.0", -1)
const _hoisted_60 = {
  key: 11,
  class: "itme"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("div", null, "XMA", -1)
const _hoisted_62 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_63 = /*#__PURE__*/_createVNode("div", null, ">12.3", -1)
const _hoisted_64 = {
  key: 12,
  class: "itme"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("div", null, "XSB", -1)
const _hoisted_66 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_67 = /*#__PURE__*/_createVNode("div", null, "≤2.0", -1)
const _hoisted_68 = {
  key: 13,
  class: "itme"
}
const _hoisted_69 = /*#__PURE__*/_createVNode("div", null, "GTH", -1)
const _hoisted_70 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_71 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_72 = /*#__PURE__*/_createVNode("div", null, "10.7~18.8", -1)
const _hoisted_73 = {
  key: 14,
  class: "itme"
}
const _hoisted_74 = /*#__PURE__*/_createVNode("div", null, "GBR", -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_76 = /*#__PURE__*/_createVNode("div", null, "≤270.0", -1)
const _hoisted_77 = {
  key: 15,
  class: "itme"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("div", null, "GAR", -1)
const _hoisted_79 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_80 = /*#__PURE__*/_createVNode("div", null, "≤420.0", -1)
const _hoisted_81 = { class: "codetxt" }
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "name" }, "评估结果", -1)
const _hoisted_83 = { class: "val" }
const _hoisted_84 = { class: "codetxt" }
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "name" }, "常见症状", -1)
const _hoisted_86 = { class: "val" }
const _hoisted_87 = { class: "codetxt" }
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "name" }, "好发疾病", -1)
const _hoisted_89 = { class: "val" }
const _hoisted_90 = { class: "codetxt" }
const _hoisted_91 = /*#__PURE__*/_createVNode("div", { class: "name" }, "调理建议", -1)
const _hoisted_92 = { class: "val" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ScoreNum = _resolveComponent("ScoreNum")

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
    return (_openBlock(), _createBlock("div", {
      class: "card",
      key: item.id
    }, [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.dataTypeNemeList[item.dataType - 1]), 1),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_ScoreNum, {
            score: parseInt(item.score),
            addZero: true
          }, null, 8, ["score"])
        ]),
        _hoisted_4
      ]),
      _createVNode("div", _hoisted_5, _toDisplayString(item.requali), 1),
      (_ctx.pulseCurveUrl && ((_ctx.dataTypeNemeList[item.dataType - 1] === '心血管功能测评') || _ctx.dataTypeNemeList[item.dataType - 1] === '心理状态测评'))
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("img", {
              class: "chartimg",
              src: _ctx.pulseCurveUrl,
              alt: "24小时脉搏波变化图"
            }, null, 8, ["src"]),
            _hoisted_6
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.poincareUrl && (_ctx.dataTypeNemeList[item.dataType - 1] === '心血管功能测评'))
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("img", {
              class: "chartimg",
              src: _ctx.poincareUrl,
              alt: "24小时Poincare散点图"
            }, null, 8, ["src"]),
            _hoisted_7
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.ecgCurveUrl && (_ctx.dataTypeNemeList[item.dataType - 1] === '寒热状态测评'))
        ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            _createVNode("img", {
              class: "chartimg",
              src: _ctx.ecgCurveUrl,
              alt: "24小时心率分布图"
            }, null, 8, ["src"]),
            _hoisted_8
          ], 64))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        (_ctx.getHasCode(item.dataType).hasXarList)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xar * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xar) < 76.62)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_13
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].xar) > 84.36)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_14
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_15
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXstList)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              _hoisted_17,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xst * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xst) < 5.9)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_18
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].xst) > 8.3)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_19
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_20
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXvlaList)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xvla * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xvla) <= 23)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_23
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_24
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXasrdList)
          ? (_openBlock(), _createBlock("div", _hoisted_25, [
              _hoisted_26,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xasrd * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xasrd) <= 13.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_27
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_28
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXbarList)
          ? (_openBlock(), _createBlock("div", _hoisted_29, [
              _hoisted_30,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xbar * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xbar) < 130)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_31
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].xbar) > 270)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_32
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_33
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXaarList)
          ? (_openBlock(), _createBlock("div", _hoisted_34, [
              _hoisted_35,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xaar * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xaar) < 160.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_36
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].xaar) > 420.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_37
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_38
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGasList)
          ? (_openBlock(), _createBlock("div", _hoisted_39, [
              _hoisted_40,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].gsa * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gsa) < 15.56)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_41
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_42
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGlaList)
          ? (_openBlock(), _createBlock("div", _hoisted_43, [
              _hoisted_44,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].gla * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gla) <= 80.61)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_45
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_46
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGsdaList)
          ? (_openBlock(), _createBlock("div", _hoisted_47, [
              _hoisted_48,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].gsda * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gsda) <= 870.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_49
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_50
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasSvlList)
          ? (_openBlock(), _createBlock("div", _hoisted_51, [
              _hoisted_52,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].svl * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].svl) <= 93.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_53
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_54
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasSmrList)
          ? (_openBlock(), _createBlock("div", _hoisted_55, [
              _hoisted_56,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].smr * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].smr) < 65.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_57
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].smr) > 79.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_58
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_59
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXmaList)
          ? (_openBlock(), _createBlock("div", _hoisted_60, [
              _hoisted_61,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].xma ? (Math.floor(_ctx.codeList[0].xma * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xma) < 12.3)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_62
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_63
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXsbList)
          ? (_openBlock(), _createBlock("div", _hoisted_64, [
              _hoisted_65,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].xsb ? (Math.floor(_ctx.codeList[0].xsb * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xsb) > 2)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_66
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_67
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGthList)
          ? (_openBlock(), _createBlock("div", _hoisted_68, [
              _hoisted_69,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].gth ? (Math.floor(_ctx.codeList[0].gth * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gth) < 10.7)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_70
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].gth) > 18.8)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_71
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_72
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGbrList)
          ? (_openBlock(), _createBlock("div", _hoisted_73, [
              _hoisted_74,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].gbr ? (Math.floor(_ctx.codeList[0].gbr * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gbr) > 270.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_75
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_76
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGarList)
          ? (_openBlock(), _createBlock("div", _hoisted_77, [
              _hoisted_78,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].gar ? (Math.floor(_ctx.codeList[0].gar * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gar) > 420.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_79
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_80
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_81, [
        _hoisted_82,
        _createVNode("span", _hoisted_83, _toDisplayString(item.requali), 1)
      ]),
      _createVNode("div", _hoisted_84, [
        _hoisted_85,
        _createVNode("span", _hoisted_86, _toDisplayString(item.symptom), 1)
      ]),
      _createVNode("div", _hoisted_87, [
        _hoisted_88,
        _createVNode("span", _hoisted_89, _toDisplayString(item.warning), 1)
      ]),
      _createVNode("div", _hoisted_90, [
        _hoisted_91,
        _createVNode("span", _hoisted_92, _toDisplayString(item.suggestion), 1)
      ])
    ]))
  }), 128))
})